var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { PaginationMetaData, Product } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import { useNavigate } from 'react-router';
var ProductService = /** @class */ (function (_super) {
    __extends(ProductService, _super);
    function ProductService() {
        var _this = _super.call(this) || this;
        _this.productsRoot = 'products';
        _this.successMessage = '';
        return _this;
    }
    ProductService.prototype.useProducts = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.inventory.products, pageNumber, filters], function () {
            return _this.get(_this.productsRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var products = plainToInstance(Product, data === null || data === void 0 ? void 0 : data.products);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { products: products, meta: meta };
            }
        });
    };
    ProductService.prototype.useMiniProducts = function (enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery([queries.inventory.products, 'mini_index'], function () {
            return _this.get("".concat(_this.productsRoot, "/mini_index"));
        }, {
            enabled: enabled,
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Product, data);
            }
        });
    };
    ProductService.prototype.useProduct = function (id, enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery(['show', queries.inventory.products, id], function () {
            return _this.get("".concat(_this.productsRoot, "/").concat(id));
        }, {
            retry: false,
            enabled: enabled && Number(id) > 0,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Product, data);
            }
        });
    };
    ProductService.prototype.useCreateProduct = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var product = _a.product, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { product: instanceToPlain(product) };
            return _this.post(_this.productsRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.inventory.products);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate('/products');
            }
        });
    };
    ProductService.getInstance = function () {
        if (!ProductService.productService) {
            ProductService.productService = new ProductService();
        }
        return ProductService.productService;
    };
    return ProductService;
}(ApiService));
export default ProductService;
